<template>
<v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">SETUP</div>
                        <div class="text-h6 font-weight-bold primary--text">Classes</div>
                        <div class="text-body-2 grey--text">Manage Classes, Add / Update / Remove Classes</div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="d-flex flex-wrap stat-chip-row">
                        <div class="stat-chip">
                            <div class="stat-chip-value">{{classCount}}</div>
                            <div class="stat-chip-label">Total Classes</div>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- Create /Update Form -->
                         <v-col cols="12">
                            <create-class-form :authToken="authToken" :school="school" :classes="classes" :schoolarms="schoolarms" :editFormRecord="editFormRecord" @refreshSignal="refreshClasses = Math.random()"/>
                        </v-col>
                        <!-- Records -->
                        <v-col cols="12">
                            <v-row class="mb-5">
                                <v-col cols="12">
                                    <v-alert
                                        type="info"
                                        dense
                                        border="left"
                                        text
                                        color="orange"
                                        >
                                        <marquee>
                                            <span v-for="(info,i) in infos" :key="i" class="black--text mr-5">
                                            {{info.content}} | &nbsp;
                                            </span>
                                        </marquee>
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <get-classes-record-axios-by-school :authToken="authToken" :school="school" :refreshSignal="refreshClasses" @get_classes="getClasses"/>
                                    <get-school-arms-record-axios :authToken="authToken" :school="school" :refreshSignal="refreshSchoolArms" @get_schoolarms="getSchoolArms"/>
                                    <classes-table-list :authToken="authToken" :school="school" :records="classes" @editFormSignal="editFormSignal" @refreshSignal="refreshClasses = Math.random()"/>
                                </v-col>
                                <!-- archive -->
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderVue from '../../components/Header.vue'
import ClassesTableList from '../../components/parts/ClassesTableList.vue';
import CreateClassForm from '../../components/parts/CreateClassForm.vue';
import GetClassesRecordAxiosBySchool from '../../components/parts/GetClassesRecordAxiosBySchool.vue';
import GetSchoolArmsRecordAxios from '../../components/parts/GetSchoolArmsRecordAxios.vue';
  export default {
    name: 'Classes',
    components: {
        HeaderVue,
        CreateClassForm,
        ClassesTableList,
        GetClassesRecordAxiosBySchool,
        GetSchoolArmsRecordAxios
    },
    mounted() {
       if (!this.authToken) {
           this.$router.push({name: 'Login'})
       }
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        schoolarms:[],
        classes:[],
        editFormRecord: null,
        refreshClasses: false,
        refreshSchoolArms: false,
        infos:[
            // {content: 'Class names cannot be changed once saved, so be sure to enter the right class name according to how it is named in your school'},
            // {content: 'The reason why we do not allow class name updates is so that users do not muddle up existing class names with vague names'},
            // {content: 'In rare cases when you make an error and you need to update it, then you can reach out to us'},
            {content: 'Manage your classes here'},
        ]
    }),
    computed:{
        classCount(){
            return this.classes.length
        }
    },
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        getSchoolArms (data) {
            this.schoolarms = data
        },
        getClasses (data) {
            this.classes = data
        },
        editFormSignal (data) {
            this.editFormRecord = data
        },

    },
  }
</script>
